export default __webpack_public_path__ + "static/motel-kitchen-b3eaeacccfb8363a23b88697f45d27ed.jpg";